import React from 'react';
import SvgIcon from '../../svgIcon/SvgIcon';

export function Error(props) {
    return (
        <SvgIcon {...props}>
            <circle cx="8" cy="8" r="8" fill="#fe6060" />
            <path
                d="M8 9.04c-.12 0-.22 0-.29-.01-.08 0-.13-.01-.17-.03-.04-.02-.06-.05-.08-.08a.605.605 0 0 1-.02-.15L7.27 4.9c0-.07 0-.12.02-.17.02-.05.05-.08.1-.1.05-.03.13-.04.22-.05a3.844 3.844 0 0 1 .77 0c.1.01.17.02.22.05.05.02.09.06.1.1.02.04.03.1.02.17l-.16 3.87c0 .06-.01.11-.02.15-.02.03-.04.06-.08.08-.04.02-.09.03-.17.04H8zm-.65 1.39c-.01-.06 0-.1.01-.14.01-.04.04-.07.09-.09.05-.02.11-.04.2-.04a3.009 3.009 0 0 1 .69 0c.09.01.15.02.2.04.05.02.08.05.09.09.01.04.02.08.02.14l-.05.78c0 .05-.01.09-.03.12-.01.03-.04.05-.08.07-.04.02-.1.03-.18.03-.08 0-.18.01-.31.01s-.23 0-.31-.01c-.08-.01-.14-.02-.18-.03-.04-.02-.07-.04-.08-.07a.213.213 0 0 1-.03-.12l-.05-.78z"
                fill="#fff"
            />
        </SvgIcon>
    );
}

Error.defaultProps = {
    viewBox: '0 0 16 16'
};

export default Error;
